import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeviceList {
  device_name: string
  device_type: string
  asset_model_name: string
  communication_status: string
  hierarchy: string
}
export interface DeviceListState {
  isLoading: boolean
  loadingError: string | null
  deviceList: DeviceList[] | null
  deviceCount: number
  httpStatus: number | null
}

const initialState: DeviceListState = {
  isLoading: true,
  loadingError: null,
  deviceList: null,
  deviceCount: 0,
  httpStatus: null
}

const deviceListSlice = createSlice({
  name: 'deviceManagementDeviceList',
  initialState,
  reducers: {
    deviceListLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        deviceList: null,
        deviceCount: 0,
        httpStatus: 0
      }
    },
    deviceListUpdateAction: (state, action: PayloadAction<{ data: DeviceList[], count: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        deviceList: action.payload.data,
        deviceCount: action.payload.count,
        httpStatus: action.payload.httpStatus
      }
    },
    deviceListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        deviceList: null,
        deviceCount: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  deviceListLoadingAction,
  deviceListUpdateAction,
  deviceListErrorAction
} = deviceListSlice.actions

export default deviceListSlice.reducer
